import { enumUnit } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const itemGroupCreateAtom = createMutationAtomFactory(
  'settings.itemGroupCreate',
  (params: {
    parentId?: string | null;
    name: string;
    number: string;
    description: string;
    notes: string;
    defaultPricingUnit?: string;
  }) => ({
    inventoryItemGroupCreate: {
      __args: {
        input: {
          parentId: params.parentId,
          name: params.name,
          number: params.number,
          description: params.description,
          notes: params.notes,
          defaultPricingUnit: params.defaultPricingUnit || enumUnit.Pounds,
        },
      },
      id: true,
      name: true,
      number: true,
      timestamps: {
        createdAt: true,
      },
    },
  }),
);
